import { useState } from 'react';
import { api, ApiError } from '../api.js';
import { Loading, Page, useApi } from '../components.js';
import { href } from '../router.js';

interface Item { type: string; targetKind: string; targetId: string; title: string; detail: string; actions: string[] }

export function ReviewPage({ exp }: { exp: string }) {
  const { data, error, refetch } = useApi<{ items: Item[] }>(`/api/expeditions/${exp}/review`);
  const [msg, setMsg] = useState<string | null>(null);
  const [owner, setOwner] = useState<Record<string, string>>({});
  const back = { href: href.expedition(exp), label: 'Expedition' };
  if (!data) return <Page title="Review" back={back}><Loading error={error} /></Page>;
  const act = async (i: Item, action: string) => {
    try {
      await api('POST', `/api/expeditions/${exp}/review`, { targetKind: i.targetKind, targetId: i.targetId, action, ...(action === 'set-owner' ? { value: owner[i.targetId] ?? '' } : {}) });
      setMsg(null);
      refetch();
    } catch (e) { setMsg((e as ApiError).message); }
  };
  return (
    <Page title={`Review (${data.items.length})`} back={back}>
      {msg && <p className="error" role="alert">{msg}</p>}
      {!data.items.length && <p className="muted">Nothing waiting for you.</p>}
      {data.items.map((i) => (
        <div className="card" key={`${i.targetKind}:${i.targetId}`}>
          <strong>{i.title}</strong> <span className="muted">· {i.type} · <a href={href.history(exp, i.targetKind, i.targetId)}>history</a></span>
          <p>{i.detail}</p>
          <div className="actions">
            {i.actions.includes('set-owner') && <input aria-label={`Owner of ${i.title}`} placeholder="Person id or name" value={owner[i.targetId] ?? ''} onChange={(e) => setOwner({ ...owner, [i.targetId]: e.target.value })} />}
            {i.actions.map((a) => <button key={a} className={a === 'reject' || a === 'delete' || a === 'private' ? 'secondary' : ''} onClick={() => act(i, a)}>{a}</button>)}
          </div>
        </div>
      ))}
    </Page>
  );
}
